import { APIS_RAOS_DATA, TIMEOUTTIME } from "@/constants/apis";
import axios from "axios";
import { ref } from "vue";
import { TOKEN } from '@/constants/labels';
import { showConsoleError } from '@/functions/errors'
import { PARAMETROS } from "@/interfaces/SmartLink/Equipos";


export async function getBandWidthDataByIp(params: PARAMETROS) {
     /**
     * Estado de la Petición AXIOS
     */
    const statusAxios = ref()

    await axios
        .get(APIS_RAOS_DATA.value.getAllBandWidthByIP, { params: params, timeout: TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}` } })
        .then((response) => {
            const finalData: any = response.data;
            const showGraphs = ref(finalData.length > 0)
            const finalObj = ref<number[][]>([])
            if (finalData.length > 0) {
                finalData.forEach((item: any) => {

                    const tiempo = new Date(item.fecha ?? '');
                    const milliseconds = tiempo.getTime();

                    const bandwidthValue = JSON.parse(item.bandwidth ?? '{"Tx": -1, "Rx": -1}');  
                    finalObj.value.push([milliseconds, bandwidthValue.Rx]);
                });
            }
            statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
        })
        .catch(function (error) {
            statusAxios.value = { status: 400, data: [], showGraphs: false }
            showConsoleError(error)
        })
    return statusAxios.value
}